var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.833 1.384c.224-.156.11-.499-.164-.499H2.561c-.275 0-.388.343-.165.499L8.451 5.6c.098.068.23.068.328 0l6.054-4.216Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.779 6.942a.289.289 0 0 1-.328 0L1.155 1.867c-.186-.13-.446 0-.446.224v9.52c0 .151.126.274.282.274h15.247a.279.279 0 0 0 .283-.275V2.09c0-.223-.26-.353-.447-.223L8.78 6.942Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.215,
  y: 0.385,
  width: 16.8,
  height: 12,
  rx: 0.25,
  fill: "#fff"
})))));
export default SvgEmail;